export const handleApiError = (error: any): string => {
  // If there's a specific error message in detail
  if (error?.response?.data?.detail) {
    return error.response.data.detail;
  }

  // If there's a status message
  if (error?.response?.data?.status) {
    if (error.response.data.status === 'invalid_otp') {
      return 'کد تایید نامعتبر است';
    }
    return error.response.data.status;
  }

  // If there's a message in the error response
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  // If there's a network error
  if (error?.message === 'Network Error') {
    return 'خطا در اتصال به سرور';
  }

  // Default error message
  return 'خطای نامشخص';
}; 